<template>
<span>
    <control-details></control-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import ControlDetails from '@/components/moduls/ControlDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'control',
    components:{
        ControlDetails,
        PageFooter
    }

    
};
</script>


